import React from 'react';
import { Col, Row } from 'reactstrap';
import { DeprecatedPanel } from '../../../../components/DeprecatedPanel';
import { InterviewDetailTab } from '../../Entities/InterviewDetailTab';
import { InterviewTabs } from '../InterviewTabs';
import { Interview } from '../../../../entities/Interview';
import { VideoControlsPanel } from '../../VideoControlsPanel';
import { InterviewTimeline } from '../../InterviewTimeline';
import { HighlightType } from '../../Entities/HighlightType';

interface PropTypes {
  activeTab: InterviewDetailTab;
  clipRange: number[];
  interview: Interview;
  interviewClipFormVisible: boolean;
  isPlaying: boolean;
  playTimestamp: number;
  selectedHighlightType: HighlightType;
  startTime: number;
  pickTime: (time: number) => void;
  setActiveTab: (tab: InterviewDetailTab) => void;
  onCreateInterviewClip: () => void;
  onInterviewClipRangeChanged: (range: number[]) => void;
  setInterviewClipFormVisible: (visible: boolean) => void;
  setInterview: (interview: Interview) => void;
  setIsPlaying: (playing: boolean) => void;
  setPlayTimestamp: (playTimestamp: number) => void;
  setSelectedHighlightType: (selectedHighlightType: HighlightType) => void;
  setStartTime: (start: number) => void;
  children: JSX.Element;
  extraComponent?: JSX.Element;
  interviewAiAssistantEnabled: boolean;
}

function DefaultVideoLayout(props: PropTypes) {
  function handleUpdateInterview(interview: Interview) {
    props.setInterview({
      ...interview,
      transcript: interview.transcript,
      interview_participants: interview.interview_participants,
      interview_automatic_questions: interview.interview_automatic_questions,
    });
  }

  return (
    <>
      <VideoControlsPanel
        interview={props.interview}
        startTime={props.startTime}
        isPlaying={props.isPlaying}
        playTimestamp={props.playTimestamp}
        onSelectTime={props.pickTime}
        onChangePlayTimestamp={props.setPlayTimestamp}
        onStartTime={props.setStartTime}
        onPlaying={props.setIsPlaying}
      />
      <DeprecatedPanel
        className='p-0'
        additionalInnerContainerClassNames='px-4 py-2'
      >
        <InterviewTimeline
          interview={props.interview}
          time={props.playTimestamp}
          clipRange={props.clipRange}
          onSelectTime={props.pickTime}
          onUpdateInterview={handleUpdateInterview}
          onCreateInterviewClip={props.onCreateInterviewClip}
          interviewClipsEditing={props.interviewClipFormVisible}
          onInterviewClipRangeChanged={props.onInterviewClipRangeChanged}
          selectedHighlightType={props.selectedHighlightType}
          onSelectedHighlightType={props.setSelectedHighlightType}
        />
      </DeprecatedPanel>
    </>
  );
}

export function DefaultTabLayout(props: PropTypes) {
  return (
    <Row>
      <Col xs='6'>
        <DefaultVideoLayout {...props} />
      </Col>
      <Col xs='6'>
        <DeprecatedPanel
          className='d-flex flex-column'
          additionalInnerContainerClassNames='p-4'
        >
          <InterviewTabs
            activeTab={props.activeTab}
            setActiveTab={props.setActiveTab}
            interviewAiAssistantEnabled={props.interviewAiAssistantEnabled}
          />
          {props.children}
        </DeprecatedPanel>
        {props.extraComponent}
      </Col>
    </Row>
  );
}
